<template>
  <div class="footer-wrap wrap">
    <div class="middle-nav first col-12 col-md-10 col-lg-10  wrap">
      <div class="row justify-content-start">
        <div class="col select-item offset-1 offset-md-2">
          <span>企业介绍</span><ul class="ul-li">
          <li @click="$router.push('/service')">服务宗旨</li>
          <li @click="$router.push('/develop')">企业发展历程</li>
          <li @click="$router.push('/partner')">合作伙伴</li>
          <li @click="$router.push('/boss')">董事长致辞</li>
<!--          <li @click="$router.push('/organization')">组织架构图</li>-->
        </ul>
        </div>
        <div class="col select-item" >
          <span @click="$router.push('/goodinfo')">商品信息</span>
          <ul class="ul-li">
            <li class="goodInfo" @click="$router.push('/goodinfo')">热卖产品
              <ul class="ul-li2 d-none d-xxl-inline">
                <li @click.stop="$router.push('/fried')">油炸电烤类</li>
                <li @click.stop="$router.push('/chinese')">中华菜类</li>
                <li @click.stop="$router.push('/charcoal')">炭烤类</li>
                <li @click.stop="$router.push('/steam')">蒸煮类</li>
                <li @click.stop="$router.push('/coated')">上粉类</li>
                <li @click.stop="$router.push('/rawmarinade')">生调理品类</li>
                <li @click.stop="$router.push('/raw')">生品类</li>
<!--                <li @click.stop="$router.push('/vegetable')">植物基</li>-->
              </ul>
            </li>
            <li @click="$router.push('/saleinfo')">产品应用</li>
          </ul>

        </div>
        <div class="col select-item" @click="$router.push('/newslist')"><span>新闻播报</span>
          <div class="ul-li">
            <li><span class="d-md-inline d-md-inline">春雪亲子教育活动</span></li>
            <li><span class="d-md-inline d-md-inline">检验检测中心领导莅临</span></li>
            <li><span class="d-md-inline d-md-inline">春雪食品千鸡宴</span></li>
            <li><span class="d-md-inline d-md-inline">工商联领导莅临春雪</span></li>
            <li><span class="d-md-inline d-md-inline">巫山县学院莅临春雪</span></li>
            <li><span class="d-md-inline d-md-inline">中国农业大学硕士莅临春雪</span></li>
          </div>
        </div>
        <div class="col select-item"><span>招聘信息</span>
          <ul class="ul-li">
            <li @click="$router.push('/account')">财务管理</li>
            <li @click="$router.push('/sale')">营销管理</li>
            <li @click="$router.push('/food')">食品研发</li>
            <li @click="$router.push('/product')">生产管理</li>
            <li @click="$router.push('/tec')">技术管理</li>
            <li @click="$router.push('/synthesis')">综合</li>
          </ul>
        </div>
<!--        <div class="col select-item d-none d-sm-block " @click="touZi"><span>投资关系</span></div>-->
      </div>
    </div>
    <div class="middle-nav col-12">
        <div class="icons">
          <span><img class="erweima" src="../../assets/img/douyin.jpg"><img class="pic" src="../../assets/img/dy.png" alt=""></span>
          <span @click="weibo"><img class="pic" src="../../assets/img/wb.png" alt=""></span>
          <span @click="toutiao"><img class="pic" src="../../assets/img/tt.png" alt=""></span>
          <span @click="bilibili"><img class="pic" src="../../assets/img/bilibli.png" alt=""></span>
          <span><img class="erweima" src="../../assets/img/weixin.jpg"><img class="pic" src="../../assets/img/wx.png" alt=""></span>

        </div>
    </div>
    <div class=" bottom">
      <div class="d-flex justify-content-center">
        <div class="col-2 col-xxl-1 bottomImg">
          <img src="../../assets/img/logo.png" alt="">
        </div>

        <div class="col-5 col-md-3 col-xl-2 left-context"  style="padding-left: .8rem">
          <div>总部</div>
          <div>青岛分公司</div>
          <div>上海分公司</div>
          <div>鲁ICP备 16035274号</div>
        </div>

        <div class="col-4  col-xxl-3 address">
          <div>山东省烟台市莱阳市富山路382号</div>
          <div>山东省青岛市崂山区香港东路185号银丰财富广场B区3102</div>
          <div>上海市徐汇区桂箐路65号新研大厦B座905室</div>
          <div>鲁公安备 37068202888902号</div>
        </div>

        <div class="col-5 col-md-4 col-lg-3 col-xxl-2">
          <div><span class="d-none d-sm-inline">TEL.</span>0535-7322849/7366168</div>
        </div>

        <ul class="col-1 row d-none d-xxl-block">
          <li>PC.265200</li>
        </ul>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "index",
  methods:{
    touZi(){
      window.open('https://open.sseinfo.com/ir2/indexkcb?language=zh_CN&stockCode=605567')
    },
    bilibili(){
      window.open('https://space.bilibili.com/1790466274')
    },
    toutiao(){
      window.open('https://www.toutiao.com/c/user/token/MS4wLjABAAAA6_pgPK8PQ8Z26UbAGD1HhZMVLb2JKk1djJrMKUKTTbZgarf0esdfi85MdR5sK28a/?')
    },
    weibo(){
      window.open('https://weibo.com/u/6432789566')
    },

  }
}
</script>

<style scoped lang="less">
.first{
  border: none !important ;
}
.footer-wrap{
  font-family: sy;
  font-weight: 600;
}
.bottom{

}
.middle-nav{
  border-bottom: 1px #D7D7D7 dashed;
  padding-right: 8%;
  .row{
    margin-top: 3rem;
    width: 100%;
  }
}
.select-item{
  padding: 0;
  font-size: 1rem;
  li:hover,>span:hover{
    color: #ffc34d;
    text-decoration: underline;
  }
  > span{
    font-size:150%;
    line-height: 3rem;
  }
  .ul-li{
    text-align: left;
    >li{
      font-size: .9rem;
      line-height: 2rem;
    }
    >span{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .goodInfo{
    position: relative;
    z-index: 2;
  }
  .ul-li2{
    color: #333;
    position: absolute;
    z-index: 10;
    top:0px;
    height:0px;
    overflow: hidden;
    left:80px;
    width: 40%;
  }
  .goodInfo:hover .ul-li2{
    line-height: 2rem;
    height: 16rem;
    text-align: left;
    color: #333;
    transition: all .3s;
  }
}
.icons{
  margin-top: 1rem;
  display: flex;
  flex-direction: row-reverse;
  .pic {
    margin-left: 1rem;
    margin-bottom: 1rem;
  }
  .erweima{
    position: absolute;
    width:100px;
    height:100px;
    top:-100px;
    display: none;
    left:-20px;
  }
  span{
    position: relative;
    &:hover img:nth-child(1){
      display: block;
    }
  }
}
.bottom{
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 1.3rem;
  .bottomImg {
    display: flex;
    align-items: center;
    img{
      width: 100%;
      height: auto;
    }
  }
  .row div{
    padding: 0;
  }
  .left-context{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (max-width: 1000px) {
  .address{
    display: none;
  }
}
@media (max-width: 768px) {
  .select-item{
    font-size: .8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue